const StatusButton = ({ label, type, onClick }) => {
  const getColors = (type) => {
    switch (type) {
      case "accept":
        return { background: "#1AA773", color: "#fff" };
      case "reject":
        return { background: "#F93737", color: "#fff" };
      case "accepted":
        return { background: "#B6EFBB", color: "#000" };
      case "rejected":
        return { background: "#F7ABAB", color: "#000" };
      default:
        return { background: "#ccc", color: "#000" };
    }
  };

  const { background, color } = getColors(type);


  const buttonStyle = {
    backgroundColor: background,
    color: color,
    border: "none",
    padding: "4px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    margin: "5px",
    height:"25px"
    
  };

  return (
    <button style={buttonStyle} onClick={onClick} className="status_button">
      {label}
    </button>
  );
};

export default StatusButton;
